import { CtaBand } from '@/components/common/CtaBand';
import { PageMeta } from '@/components/common/PageMeta';
import { Hero, HomeCta } from '@/pages/Home/data';
import { ClientsSection } from '@/pages/Home/sections/ClientsSection';
import { DeliverablesSection } from '@/pages/Home/sections/DeliverablesSection';
import { EngagementSection } from '@/pages/Home/sections/EngagementSection';
import { FaqSection } from '@/pages/Home/sections/FaqSection';
import { GuaranteeSection } from '@/pages/Home/sections/GuaranteeSection';
import { HeroSection } from '@/pages/Home/sections/HeroSection';
import { ProcessSection } from '@/pages/Home/sections/ProcessSection';
import { ServicesSection } from '@/pages/Home/sections/ServicesSection';

export default function Home() {
  return (
    <>
      <PageMeta description={Hero.description} />
      <HeroSection />
      <GuaranteeSection />
      <ServicesSection />
      <ProcessSection />
      <ClientsSection />
      <DeliverablesSection />
      <FaqSection />
      <EngagementSection />
      <CtaBand title={HomeCta.title} description={HomeCta.description} />
    </>
  );
}